import { render, staticRenderFns } from "./team-member-settings.vue?vue&type=template&id=fc1a540e&scoped=true&"
import script from "./team-member-settings.vue?vue&type=script&lang=ts&"
export * from "./team-member-settings.vue?vue&type=script&lang=ts&"
import style0 from "./team-member-settings.vue?vue&type=style&index=0&id=fc1a540e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1a540e",
  null
  
)

export default component.exports